export default __webpack_public_path__ + "static/media/forum.4182d9f1.png";